import {brandsBase} from '@root/brands/brandsBase';
import type {BrandBase} from '@root/brands/BrandBase';

export type BrandId = keyof typeof brandsBase & string;

export const getBrandBase = (brandId: BrandId): BrandBase => brandsBase[brandId];
